export const removeOrderError = {
  'invalid delete when DO is only one': 'minimum-one-delivery',
  "can't unassign vendor request delivery order": 'delivery/failed-to-unassigned-request',
  "Cannot unassign order from this fleet task": 'delivery/cannot-unassign-from-fleet-task',
  default: 'invalid/invalid-input-format',
}

export const transitionError = {
  'Complete all activities to do the transition': 'invalid/activities-must-be-completed',
  "can't cancel fleet task that has vendor request delivery order": 'failed-to-canceled',
  default: 'invalid/invalid-fields',
}
